import Icon from '../components/Icon.vue'

Icon.register({
  'greater-than-equal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M55.2 107.7c-18.3-6-27.7-24.3-21.1-40.8l12-29.9c6.6-16.5 26.9-25.1 45.1-19.1l301.7 120c13.8 4.5 23 16.6 23 30.2v16c0 13.6-9.2 25.6-23 30.2l-301.4 119.9c-18.4 6-38.7-2.5-45.4-19.1l-12.1-30.1c-6.7-16.6 2.8-35 21.2-41l175.4-68zM424 400c13.3 0 24 10.7 24 24v48c0 13.3-10.8 24-24 24h-400c-13.3 0-24-10.8-24-24v-48c0-13.3 10.8-24 24-24h400z'
      }
    ]
  }
})
